<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.AssociationBusinessInformation')"
      width="800px"
      :close-on-click-modal="false"
      class="app-main-inner"
    >
      <div style="padding:0 0 5px 0">
        <span>
          {{ $t('SeaExport.BusinessNo') }}：{{ aData.bNo }}&nbsp;&nbsp;&nbsp;
          {{ $t('SeaExport.BusinessStatus') }}：{{ BusinessStatus }}&nbsp;&nbsp;&nbsp;
        </span>
      </div>
      <div style="padding:0 0 5px 0">
        <span>
          {{ $t('SeaExport.CargoQuantityDescription') }}：{{ lbTotalDesc.lblContainerDesc }}&nbsp;&nbsp;&nbsp;
          {{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotalDesc.lbTotalQuantity }}&nbsp;&nbsp;&nbsp;
          {{ $t('SeaExport.TotalWeight') }}：{{ lbTotalDesc.lbTotalWeight }}&nbsp;&nbsp;&nbsp;
          {{ $t('SeaExport.TotalCubage') }}：{{ lbTotalDesc.lbTotalCubage }}&nbsp;&nbsp;&nbsp;
        </span>
      </div>
      <cargo-ag-grid
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:300px"
        @gridReady="params=>gridApi=params.api"
      />
      <span slot="footer">
        <el-button v-if="aData.lob === job.lob" type="primary" no="SynchronizedSetting" @click="showSynchronizedSettingDialog">{{ $t('Pricing.Setting') }}</el-button>
        <el-button type="primary" no="1" @click="addEventHander">{{ $t('SeaExport.Synchronization') }}</el-button>
        <el-button no="2" @click="innerVisible=false">{{ $t('SeaExport.Close') }}</el-button>
      </span>
    </el-dialog>
    <synchronized-fields-window
      v-show="synchronizedDialog.visible"
      :visible.sync="synchronizedDialog.visible"
      :container-info="synchronizedDialog.containerInfo"
      :defalut-all-true="aData.lob !== job.lob"
    />
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ContainerUtil } from '@/class/cargo/model/utils/ContainerUtil'
import ContainerNoHelper from '@/utils/containerNoHelper'
import { DataPushCompareUtils } from '@/class/cargo/model/utils/DataPushCompareUtils'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import { sortByMultiField } from '@/utils'
import * as NumberUtils from '@/utils/NumberUtils'
import StrUtils from '@/utils/StrUtils'
import { synchronizationContainer } from '@/api/seaExport/containerUsage'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { getContainerUsages } from '@/api/seaExport/specialGoods'
import SynchronizedFieldsWindow from '@/components/Cargo/Job/synchronizedFieldsWindow'
import { getLoading4Cxt } from '@/utils/utilBaseElement'

export default {
  name: 'AssociatedBusinessDialog',
  components: { SynchronizedFieldsWindow, cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    aData: { type: Object, required: false },
    job: { type: Object, required: false }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      columnDefs:
        [
          {
            headerName: this.$t('SeaExport.ContainerSize'),
            field: 'eqSize',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span',
              attrs: { classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'eqSize') } }
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerType'),
            field: 'eqType',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span',
              attrs: { classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'eqType') } }
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerNo'),
            field: 'containerNo',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span',
              attrs: { classFunc: (params) => { return this.containerNbrStyleFunction(params.data) } }
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerWeight'),
            field: 'containerWeight',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span',
              precision: 3,
              attrs: {
                classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'containerWeight') },
                textConverter: (val) => {
                  return !val ? '' : ColumnUtils.number3ColumnLabelFunc(val)
                }
              }
            }
          },
          {
            headerName: this.$t('SeaExport.SealNo'),
            field: 'sealNo',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span',
              attrs: { classFunc: (params) => { return this.sealNoStyleFunction(params.data) } }
            }
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            field: 'quantity',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span',
              precision: 0,
              attrs: {
                classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'quantity') },
                textConverter: (val) => {
                  return !val ? '' : ColumnUtils.numberColumnLabelFunc(val)
                }
              }
            }
          },
          {
            headerName: this.$t('SeaExport.GrossWeight'),
            field: 'weight',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span',
              precision: 3,
              attrs: {
                classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'weight') },
                textConverter: (val) => {
                  return !val ? '' : ColumnUtils.number3ColumnLabelFunc(val)
                }
              }
            }
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            field: 'cubage',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span',
              precision: 3,
              attrs: {
                classFunc: (params) => { return ContainerUtil.containerPushDataStyleFunction(params.data, 'cubage') },
                textConverter: (val) => {
                  return !val ? '' : ColumnUtils.number3ColumnLabelFunc(val)
                }
              }
            }
          },
          {
            headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
            field: 'cargoName',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span'
            }
          },
          {
            headerName: this.$t('SeaExport.Marks'),
            field: 'mark',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span'
            }
          },
          {
            headerName: this.$t('SeaExport.Soc'),
            field: 'soc',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'el-checkbox'
            }
          },
          {
            headerName: this.$t('SeaExport.Inspection'),
            field: 'inSpected',
            width: 100,
            cellRenderer: (params) => {
              return this.subInSpectedLabelFunc(params.data)
            }
          },
          {
            headerName: 'HSCODE',
            field: 'hsCode',
            width: 100,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              isEdit: false,
              tag: 'span',
              valueChanged: p => { this.onCellChange(p) }
            }
          },
          {
            headerName: this.$t('SeaExport.ApproachDate'),
            field: 'approachDate',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.PlayDate'),
            field: 'playDate',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.LoadingPort'),
            field: 'loadingPort',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.PortOfDestination'),
            field: 'destinationPort',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.TheArrivalOfPacketsSent'),
            field: 'transportMessageDate',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.CustomsClearanceInfo'),
            field: 'customReleaseDate',
            width: 100,
            cellRenderer: (params) => {
              return this.releaseDateLabelFunc(params.data, 'customReleaseDate')
            }
          },
          {
            headerName: this.$t('SeaExport.WharfReleaseInfo'),
            field: 'wharfReleaseDate',
            width: 100,
            cellRenderer: (params) => {
              return this.releaseDateLabelFunc(params.data, 'wharfReleaseDate')
            }
          },
          {
            headerName: this.$t('SeaExport.ContainerAscription'),
            field: 'containerAscription',
            width: 100,
            cellRenderer: (params) => {
              return this.containerAscriptionFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.PlateNumber'),
            field: 'plateNumber',
            width: 100
          },
          {
            headerName: this.$t('SeaExport.plateApproachDate'),
            field: 'plateApproachDate',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.platePlayDate'),
            field: 'platePlayDate',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('SeaExport.Remarks'),
            field: 'remark',
            width: 100
          }
        ],
      rowData: [],
      gridApi: null,
      BusinessStatus: '',
      lbTotalDesc: { // 货物描述
        lblContainerDesc: '',
        lbTotalQuantity: '',
        lbTotalWeight: '',
        lbTotalCubage: ''
      },
      synchronizedDialog: { // 同步字段设置
        visible: false,
        containerInfo: {
          containerSize: true,
          containerType: true,
          containerNo: true,
          containerWeight: true,
          sealNo: true,
          itemCount: true,
          grossWeight: true,
          cubage: true
        }
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.show()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.show()
    }
  },
  methods: {
    show() {
      this.rowData = this.sortByOrder(this.aData.usagesList)
      // 赋值 箱子信息
      for (const usage of this.aData.usagesList) {
        const container = usage.container
        if (container) {
          usage.approachDate = container.approachDate
          usage.playDate = container.playDate
          usage.loadingPort = container.loadingPort
          usage.dischargingPort = container.dischargingPort
          usage.destinationPort = container.destinationPort
          usage.transportMessageDate = container.transportMessageDate
          usage.wharfReleaseDate = container.wharfReleaseDate
          usage.customReleaseDate = container.customReleaseDate
          usage.containerAscription = container.containerAscription
          usage.plateNumber = container.plateNumber
          usage.plateApproachDate = container.plateApproachDate
          usage.platePlayDate = container.platePlayDate
        }
      }
      this.BusinessStatus = this.getJobStateCN(this.aData.jobState)
      let quantity = 0
      let weight = 0
      let cubage = 0

      const containerMap = {}
      for (const usage of this.aData.usagesList) {
        quantity += usage.quantity
        if (!isNaN(usage.weight)) { weight += usage.weight }
        if (!isNaN(usage.cubage)) { cubage += usage.cubage }
        const c = usage.container
        if (c) {
          if (!containerMap.hasOwnProperty(c.eqSize + c.eqType)) {
            containerMap[c.eqSize + c.eqType] = 1
          } else {
            containerMap[c.eqSize + c.eqType] += 1
          }
        }
      }
      this.lbTotalDesc.lbTotalQuantity = NumberUtils.formatNumber(quantity, 0)
      this.lbTotalDesc.lbTotalWeight = NumberUtils.formatNumber(weight, 3)
      this.lbTotalDesc.lbTotalCubage = NumberUtils.formatNumber(cubage, 3)
      this.lbTotalDesc.lblContainerDesc = this.getContainerDesc(containerMap)
    },
    // 按照指定字段排序
    sortByOrder(categoryArray) {
      if (categoryArray === null || categoryArray.length === 0) {
        return null
      } else {
        categoryArray = sortByMultiField(categoryArray, ['dateCreated'], false)
      }
      return categoryArray
    },
    getContainerDesc(containerMap) {
      let containerDesc = ''
      for (const key in containerMap) {
        if (StrUtils.isEmpty(containerDesc)) {
          containerDesc = (containerMap[key] + ' * ' + key)
        } else {
          containerDesc += (',' + containerMap[key] + ' * ' + key)
        }
      }
      return StrUtils.isEmpty(containerDesc) ? this.$t('CargoMsg.Cargo_None') : containerDesc
    },
    getJobStateCN(state) {
      if (state === 0) {
        return this.$t('CargoMsg.Cargo_PositiveOperation')
      } else if (state === 1) {
        return this.$t('CargoMsg.Cargo_Submitted')
      } else if (state === 2) {
        return this.$t('CargoMsg.Cargo_Approved')
      } else if (state === 3) {
        return this.$t('CargoMsg.Cargo_ShutOut')
      } else if (state === -1) {
        return this.$t('CargoMsg.Cargo_PendingPrice')
      } else if (state === 11) {
        return this.$t('CargoMsg.Cargo_PreSubmission')
      } else if (state === 12) {
        return this.$t('CargoMsg.Cargo_Denied')
      }
      return this.$t('CargoMsg.Cargo_UnKnownStatus')
    },
    // 同步
    addEventHander() {
      this.$confirm('确定同步之后不允许再撤销，是否确认同步？', this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'info'
      }).then(async() => {
        let num = 0
        if (!this.job) {
          this.$message.warning(this.$t('Message.NoSynchronizationContent'))
          return
        }
        if (this.job.lob === 'SE') {
          await new SeaExportJob(this.job).getSpecialGoods()
        }
        for (let s; s < this.job.specialGoods.length; s++) {
          if (num > 0) break
          const sg = this.job.specialGoods[s]
          if (sg && sg.uuid) {
            sg.containerUsages = await getContainerUsages({ specialGoodsUuid: sg.uuid }).then((res) =>
              res.data ? res.data : null
            )
          }
          if (sg.containerUsages) {
            num = num + sg.containerUsages.length
          }
        }
        if (num > 0) {
          this.$confirm(this.$t('Message.ThereSynchronizationSpecialGoodsSynchronize'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            type: 'success'
          }).then(() => {
            this.synchronization()
          })
        } else {
          this.synchronization()
        }
      })
    },
    // 同步
    synchronization() {
      let jobNo = ''
      if (this.job.trustFromJob) {
        jobNo = this.job.trustFromJob
      } else {
        jobNo = this.job.relatedJob
      }
      const data =
        {
          removeJobKey: this.job.uuid,
          addJobNo: jobNo,
          containerInfo: this.synchronizedDialog.containerInfo
        }
      // 调用api
      this.loading = getLoading4Cxt()
      synchronizationContainer(data).then(res => { this.savePortsHandler(res.data) }).finally(() => {
        this.loading.close()
      })
    },
    savePortsHandler(data) {
      // 调用父组件
      this.$emit('refresh')
      this.$message.success(this.$t('Message.SynchronizationSucceeded'))
      this.innerVisible = false
    },
    containerNbrStyleFunction(usage) {
      if (!StrUtils.isEmpty(usage.containerNo)) {
        if (usage && !ContainerNoHelper.checkContainerNo(usage.containerNo)) {
          return 'data-red'
        }
        if (!StrUtils.isEmpty(usage.containerUuid) && DataPushCompareUtils.comparePushData(this.$t('SeaExport.ContainerNo'), usage.containerNo, usage.containerUuid)) {
          return 'data-blue'
        }
      }
      return ''
    },
    sealNoStyleFunction(usage) {
      if (!StrUtils.isEmpty(usage.containerUuid)) {
        if (usage.isReSealed) {
          return 'data-red'
        }
        if (!StrUtils.isEmpty(usage.containerUuid) && DataPushCompareUtils.comparePushData(this.$t('SeaExport.SealNo'), usage.sealNo, usage.containerUuid)) {
          return 'data-blue'
        }
      }
      return ''
    },
    containerAscriptionFunc(val) {
      for (const item of SeaExportConstants.CONTAINER_ASCRIPTION_TYPE) {
        if (item.code === val) {
          return item.chineseName
        }
      }
    },
    subInSpectedLabelFunc(data) {
      if (data && data.container) {
        const isInSpected = data.container.inSpected
        return isInSpected ? this.$t('Message.Yes') : this.$t('Message.No')
      }
      return ''
    },
    /**
     * 放行信息转换
     */
    releaseDateLabelFunc(data, fieldName) {
      if (data.container != null) {
        const value = data.container[fieldName]
        if (value != null) {
          return 'Y(' + ColumnUtils.dateLabelFunc(value) + ')'
        }
      }
      return 'N'
    },
    showSynchronizedSettingDialog() {
      // CARGO-43360 增加同步字段设置
      this.synchronizedDialog.visible = true
    }
  }
}
</script>
